import { render } from "./CalendarDays.vue?vue&type=template&id=df67e5f4&scoped=true&ts=true"
import script from "./CalendarDays.vue?vue&type=script&lang=ts"
export * from "./CalendarDays.vue?vue&type=script&lang=ts"

import "./CalendarDays.vue?vue&type=style&index=0&id=df67e5f4&scoped=true&lang=scss"

import exportComponent from "/opt/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-df67e5f4"]])

export default __exports__